class Toggle {
    constructor(element) {
        this.isDisabled = element.classList.contains('form__toggle--disabled');
        this.toggleButton = element.querySelector(".form__toggle-button");
        this.radioButtons = element.querySelectorAll("input[type='radio']");

        if(!this.isDisabled) {
            window.addEventListener('load', () => {
                if(!this.hasCheckedRadioBtn()) {
                    this.radioButtons[0].click();
                }
            })
            this.toggleButton.addEventListener('click', () => this.toggleRadioBtnStatus());
        }
    }

    hasCheckedRadioBtn() {
        let checked = false;
        this.radioButtons.forEach((radio) => {
            if(radio.checked) checked = true;
        })
        return checked;
    }

    toggleRadioBtnStatus() {
        let unselectedRadio;
        this.radioButtons.forEach((radio) => {
            if(!radio.checked) {
                unselectedRadio = radio;
            }
        })
        unselectedRadio.click();
    }
}

export default Toggle;